/* eslint-disable no-unused-vars */
export enum SurveySortTab {
  BEST_MATCH = 0,
  SHORT_SURVEYS = 1,
  MOST_POINTS = 2,
  MAX_POINTS_PER_MIN = 3,
  SURVEY_PROFILER = 4,
}

export interface SortTabItem {
  label: string;
  disabled?: boolean;
}

export interface SortTabsProps {
  tabs: SortTabItem[];
  selectedTab: SurveySortTab;
  onTabChanged: (tab: SurveySortTab) => void;
}

export interface MySurveyProps {
  newSurveys: SurveySetProps;
  completedSurveys: SurveySetProps;
  onViewMoreClicked: (isCompletedSurveys: boolean) => void;
  isNewSurveysLoading?: boolean;
  isCompletedSurveysLoading?: boolean;
  onStartSurveyClicked: (url: string, key: string, id: number) => void;
  isError?: boolean;
}

export interface AllSurveysProps {
  surveysToDisplay: SurveySetProps;
  onStartSurveyClicked: (url: string, key: string, id: number) => void;
}

export interface SurveySetProps {
  title: string;
  isCompletedSurveys: boolean;
  statusText: string;
  headerItems: string[];
  surveyItems: SurveyItemProps[];
  setTopMargin?: boolean;
  onViewMoreClicked?: (isCompletedSurveys: boolean) => void;
  isLoading?: boolean;
  isError?: boolean;
  showAllSurveys?: boolean;
  onStartSurveyClicked?: (url: string, key: string, id: number) => void;
  isMobile?: boolean;
  totalCount: number;
}

export interface SurveyItemProps {
  surveyName: string;
  surveyNumber: number;
  id: number;
  category: string;
  timeLeft?: string;
  timeToComplete?: string;
  points: number;
  conversion?: number;
  score?: number;
  perClick?: number;
  totalQuotas: number;
  quotaType?: string;
  totalRemaining?: number;
  isCompletedSurveys?: boolean;
  completedDate?: string;
  url?: string;
  providerKey?: string;
  onStartSurveyClicked?: (url: string, key: string, id: number) => void;
  isMobile?: boolean;
  status?: string;
}

export interface SurveyHeaderProps {
  headerItems: string[];
  isCompletedSurveys: boolean;
}

export interface BannerProps {
  onCompleteProfile: () => void;
}

export interface NotificationBannerProps {
  date: string;
  title: string;
  description: string;
  dismissNotification: () => void;
}
